import DropDownBox from './src/DropDownBox'

DropDownBox.install = function (Vue) {
    Vue.component(DropDownBox.name, DropDownBox);
};

export default DropDownBox;